import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import ModalWrapper from './ModalWrapper';

const SaveSearchModal = ({
    show,
    onHide,
    onSave,
    initialName = '',
    isUpdate = false,
}) => {
    const [searchName, setSearchName] = useState(initialName);

    // Update search name when modal opens with new initialName
    useEffect(() => {
        if (show) {
            setSearchName(initialName);
        }
    }, [show, initialName]);

    const handleSave = () => {
        if (searchName.trim()) {
            onSave(searchName.trim());
            if (!isUpdate) {
                setSearchName('');
            }
            onHide();
        }
    };

    const handleCancel = () => {
        // Don't clear the name if it's an update operation
        if (!isUpdate) {
            setSearchName('');
        }
        onHide();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    };

    return (
        <ModalWrapper
            show={show}
            onHide={handleCancel}
            headerClass='w-100 text-start'
            title={isUpdate ? "Update This Search" : "Save This Search"}
            showFooter={false}
        >
            <div className='modal-search-input'>
                <label 
                    htmlFor="search-name"
                    className='modal-search-label'
                >
                    Name your search to reuse it anytime.
                </label>
                <input
                    id="search-name"
                    type="text"
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter search name..."
                    autoFocus
                />
            </div>
            
            <div className='modal-actions'>
                <button 
                    type='button' 
                    className='filters-btn'
                    onClick={handleCancel}
                >
                    Cancel
                </button>
                <Button 
                    variant='primary' 
                    className='modal-confirm-btn'
                    onClick={handleSave}
                    disabled={!searchName.trim()}
                    style={{
                        opacity: searchName.trim() ? 1 : 0.6,
                        cursor: searchName.trim() ? 'pointer' : 'not-allowed'
                    }}
                >
                    {isUpdate ? 'Update & Search' : 'Save & Search'}
                </Button>
            </div>
        </ModalWrapper>
    );
};

export default SaveSearchModal;
